<template>
  <div>
    <base-title
      :title="StringLanguage.localization"
      :subtitle="
        onBoardDone ? StringLanguage.configurations : StringLanguage.back
      "
      :link="onBoardDone ? 'configuracoes' : 'onboard'"
    />

    <!-- Primeiro passo -->
    <base-box class="search-address" v-if="updateLocation">
      <div class="address">
        <div class="name">
          <address-input
            ref="addressInput"
            @selectedAddress="onAddressSelected"
          />
        </div>
        <div class="number" v-if="missingNumber">
          <base-input label="Número" v-model="addressNumber" ref="number" />
        </div>
        <base-message
          class="mb_10 flex"
          design="red"
          v-if="addressNumberError.status && !!isMobile"
        >
          {{ addressNumberError.message }}
        </base-message>
        <div class="next" v-if="missingNumber && !selectedAddress">
          <base-button
            text="Confirmar"
            @click="validateNumber()"
            class="w-100 mt_10 mb_15 big"
          />
        </div>
      </div>

      <base-message
        class="mb_15"
        design="red"
        v-if="addressNumberError.status && !isMobile"
      >
        {{ addressNumberError.message }}
      </base-message>
    </base-box>

    <div v-if="updateLocation && selectedAddress">
      <base-box
        v-if="
          !!selectedAddress.geolocation &&
          !!selectedAddress.geolocation.latitude
        "
        class="mb_0"
      >
        <div class="map-box">
          <l-map
            ref="map"
            style="width: 100%"
            :scroll-wheel-zoom="false"
            :minZoom="mapConfigs.minZoom"
            :maxZoom="mapConfigs.maxZoom"
            :bounds="mapConfigs.bounds"
            :zoom="mapConfigs.zoom"
            :center="[
              selectedAddress.geolocation.latitude,
              selectedAddress.geolocation.longitude,
            ]"
            @update:center="markerMoved"
          >
            <l-tile-layer
              :url="mapConfigs.mapURL"
              :attribution="mapConfigs.mapAttribution"
            />
            <!-- <l-marker :lat-lng="mapConfigs.markerPosition" /> -->
          </l-map>
          <div class="map-pseudo-marker">
            <i class="fa fa-map-marker-alt" />
          </div>
        </div>

        <base-button
          text="Confirmar"
          class="w-100 mt_20 big"
          @click="selectAddress"
        />
      </base-box>
      <base-box v-else>
        <l-map
          style="width: 100%"
          :options="{ zoomControl: false }"
          :scroll-wheel-zoom="false"
          :minZoom="3"
          :maxZoom="3"
          :zoom="3"
          :bounds="defaultBounds"
          :center="[-16.755334, -48.856434]"
        >
          <l-tile-layer
            :url="mapConfigs.mapURL"
            :attribution="mapConfigs.mapAttribution"
          />
        </l-map>
      </base-box>
    </div>
    <base-box class="form-address pb_5" v-if="!updateLocation">
      <div class="row">
        <div
          class="col-lg-6 col-md-6 col-xs-12 relative"
          :class="!!isMobile && 'mb_15'"
          v-if="address.geolocation && address.geolocation.latitude"
        >
          <l-map
            style="
              width: 100%;
              height: 335px;
              pointer-events: none;
              border-radius: 5px;
            "
            :options="{
              zoomControl: false,
              dragging: false,
              touchZoom: false,
              doubleClickZoom: false,
              boxZoom: false,
              keyboard: false,
            }"
            :scroll-wheel-zoom="false"
            :zoom="15"
            :center="[
              address.geolocation.latitude,
              address.geolocation.longitude,
            ]"
          >
            <l-tile-layer
              :url="mapConfigs.mapURL"
              :attribution="mapConfigs.mapAttribution"
            />
          </l-map>
          <div class="map-pseudo-marker">
            <i class="fa fa-map-marker-alt" />
          </div>
        </div>
        <div class="col-lg-6 col-md-6 col-xs-12" :class="!isMobile && 'pl_5'">
          <div class="address-box-title">
            <base-label text="Endereço da sua loja" class="fs-16 mb_0" />
            <span
              class="edit"
              @click="
                updateLocation = true;
                addressNumber = '';
              "
              >Editar</span
            >
          </div>
          <p class="address-text">{{ formatedAddress }}</p>
          <base-input
            :label="StringLanguage.complement"
            v-model="address.complement"
            :disabled="!address.zipcode"
            :class="!isMobile ? 'mb_20' : 'mb_15'"
          />
          <base-input
            label="Ponto de referência"
            v-model="address.observation"
          />

          <base-checkbox
            v-model="allowLocation"
            :checked="allowLocation"
            class="mt_30 mb_20"
          >
            <p class="hide-address">Permitir retirada no balcão</p>
          </base-checkbox>

          <div class="row" :class="!isMobile && 'half-cols'">
            <div class="col-lg-6">
              <base-input
                :label="StringLanguage.minWithdrawAtCounterTime"
                v-model="times.minDesk"
                :disabled="!allowLocation"
                :moneyMask="StringLanguage.timeConfigs.minutes"
                :max="8"
                :valid="userError !== 'minDesk'"
                @focus="clearError('minDesk')"
                design="two"
              />
            </div>
            <div class="col-lg-6">
              <base-input
                :label="StringLanguage.maxWithdrawAtCounterTime"
                v-model="times.maxDesk"
                :disabled="!allowLocation"
                :moneyMask="StringLanguage.timeConfigs.minutes"
                :max="8"
                :valid="userError !== 'maxDesk'"
                @focus="clearError('maxDesk')"
                design="two"
              />
            </div>
          </div>
        </div>
      </div>

      <!--
        <base-input :label="StringLanguage.zipCode" v-model="address.zipcode" @change="searchZipcode(address.zipcode)" :mask="StringLanguage.zipCodeMask" @paste.prevent=""/> -->
      <!-- <base-input :label="StringLanguage.address" v-model="address.address" :disabled="!address.zipcode"/>
        <div class="row">
            <div class="col-lg-12 col-xs-12 ">
                <base-input :label="StringLanguage.district" v-model="address.district" :disabled="!address.zipcode"/>
            </div>
            <div class="col-lg-12 col-xs-12 ">
                <base-input :label="StringLanguage.city" v-model="address.city" :disabled="!address.zipcode"/>
            </div>
        </div>
        <div class="row">
            <div class="col-lg-6 col-xs-6 pr_7">
                <base-input :label="StringLanguage.state" v-model="address.state" :disabled="!address.zipcode"/>
            </div>
            <div class="col-lg-6 col-xs-6 pl_7">
                <base-input :label="StringLanguage.country" v-model="address.country" :disabled="!address.zipcode"/>
            </div>
        </div> -->
    </base-box>
    <div
      class="d-flex justify-end w-100"
      v-if="!updateLocation && hasChanges()"
    >
      <base-button design="save" @click="onSave" />
    </div>
  </div>
</template>
<script>
import { mapState } from 'vuex';
import { TheMask } from 'vue-the-mask';
import Vue from 'vue';
import Geolocation from 'easyjs/lib/Schema/Address/Geolocation';
import { latLng } from 'leaflet';
import { LMap, LTileLayer, LMarker } from '@eluiz/vue2-leaflet';
import Location from '@/plugins/core/schema/configurations/BasicInfo/Location';
import BrasilStates from '@/plugins/states';

import StoreAPI from '@/api/store';
import AccountApi from '@/api/account';
import AddressAPI from '@/api/address';

import BaseMessage from '@/components/Message';
import BaseTitle from '@/components/Title';
import BaseButton from '@/components/Button';
import BaseBox from '@/components/Box';
import BaseInput from '@/components/Input';
import BaseCheckbox from '@/components/Checkbox';
import BaseLabel from '@/components/Label';
import BaseQuestion from '@/components/Question';

import AddressInput from '@/containers/AddressInput';

export default {
  data() {
    return {
      addressNumber: '',
      addressNumberError: {
        message: '',
        status: false,
      },
      missingNumber: false,
      tempAddress: {},
      updateLocation: false,
      allowLocation: false,
      lastScheduledSearch: null,
      keys: { hideOnlineLocation: true },
      addressString: null,
      addressOptions: [],
      selectedOption: null,
      selectedAddress: null,
      updatedMarker: null,
      address: new Location(),
      timezoneOffset: null,
      phoneDDD: null,
      original: {
        address: new Location(),
        keys: { hideOnlineLocation: true },
        timezoneOffset: null,
        phoneDDD: null,
        delivery_time: null,
      },
      defaultBounds: null,
      mapConfigs: {
        name: 'locationMap',
        zoom: 17,
        minZoom: 15,
        maxZoom: 18,
        bounds: null,
        mapCenter: latLng(-16.755334, -48.856434),
        mapURL:
          'https://mt0.google.com/vt/lyrs=m&x={x}&y={y}&z={z}&apistyle=s.e%3Ag%7Cp.c%3A%23ff242f3e%2Cs.e%3Al.t.f%7Cp.c%3A%23ff746855%2Cs.e%3Al.t.s%7Cp.c%3A%23ff242f3e%2Cs.t%3A19%7Cs.e%3Al.t.f%7Cp.c%3A%23ffd59563%2Cs.t%3A2%7Cs.e%3Al.t.f%7Cp.c%3A%23ffd59563%2Cs.t%3A40%7Cs.e%3Ag%7Cp.c%3A%23ff263c3f%2Cs.t%3A40%7Cs.e%3Al.t.f%7Cp.c%3A%23ff6b9a76%2Cs.t%3A3%7Cs.e%3Ag%7Cp.c%3A%23ff38414e%2Cs.t%3A3%7Cs.e%3Ag.s%7Cp.c%3A%23ff212a37%2Cs.t%3A3%7Cs.e%3Al.t.f%7Cp.c%3A%23ff9ca5b3%2Cs.t%3A49%7Cs.e%3Ag%7Cp.c%3A%23ff746855%2Cs.t%3A49%7Cs.e%3Ag.s%7Cp.c%3A%23ff1f2835%2Cs.t%3A49%7Cs.e%3Al.t.f%7Cp.c%3A%23fff3d19c%2Cs.t%3A4%7Cs.e%3Ag%7Cp.c%3A%23ff2f3948%2Cs.t%3A66%7Cs.e%3Al.t.f%7Cp.c%3A%23ffd59563%2Cs.t%3A6%7Cs.e%3Ag%7Cp.c%3A%23ff17263c%2Cs.t%3A6%7Cs.e%3Al.t.f%7Cp.c%3A%23ff515c6d%2Cs.t%3A6%7Cs.e%3Al.t.s%7Cp.c%3A%23ff17263c',
        mapAttribution:
          "<a href='https://google.com/maps'>Powered by Google</a>",
        markerPosition: latLng(-16.755334, -48.856434),
      },
      userError: null,
      times: { minDesk: 0, maxDesk: 0 },
    };
  },
  mounted() {
    const self = this;
    StoreAPI.storeGetConfiguration().then((response) => {
      self.set(response);
    });
  },
  beforeRouteLeave(to, from, next) {
    if (this.hasChanges()) {
      confirm(`${StringLanguage.confirmComplement}`, (res) => {
        if (res) next();
      });
    } else {
      next();
    }
  },
  methods: {
    hasChanges() {
      return (
        JSON.stringify(this.original.address) !==
          JSON.stringify(this.address) ||
        JSON.stringify(this.original.delivery_time) !==
          JSON.stringify(this.times) ||
        JSON.stringify(this.original.keys) !== JSON.stringify(this.keys)
      );
    },
    onSave() {
      if (this.hasChanges()) {
        if (this.validateTimes()) {
          switch (this.isAddressValid()) {
            case 'geolocation':
              alert(StringLanguage.errorGeolocationInvalid);
              return false;
            case 'address':
              alert(StringLanguage.errorAddressInvalid);
              return false;
            case 'number':
              alert(StringLanguage.errorNumberInvalid);
              return false;
            case 'zipcode':
              alert(StringLanguage.errorZipCodeInvalid);
              return false;
            case 'district':
              alert(StringLanguage.errorDistrictInvalid);
              return false;
            case 'city':
              alert(StringLanguage.errorCityInvalid);
              return false;
            case 'state':
              alert(StringLanguage.errorStateInvalid);
              return false;
            case 'country':
              alert(StringLanguage.errorCountryInvalid);
              return false;
            default:
              this.save();
          }
        }
      } else {
        alert(StringLanguage.noChanges);
      }
    },
    clearError(prop) {
      if (this.userError === prop) this.userError = null;
    },
    validateTimes() {
      const { times } = this;
      const { allowLocation } = this;

      if (
        this.validTime(times.minDesk, 'minDesk', !allowLocation) ||
        this.validTime(times.maxDesk, 'maxDesk', !allowLocation)
      ) {
        alert(StringLanguage.errorTimeInvalid);
        return false;
      }

      if (allowLocation && +times.maxDesk <= +times.minDesk) {
        this.userError = 'maxDesk';

        alert(StringLanguage.errorMaxMinWithdrawAtCounterTime);
        return false;
      }

      return true;
    },
    validTime(value, prop, ignoreValidation = false) {
      if (ignoreValidation) return false;

      if (+value <= 0) {
        this.userError = prop;
        return true;
      }
    },
    async validateNumber() {
      if (!this.addressNumber && this.$refs.number) {
        this.addressNumberError = {
          message: 'Por favor, informe o número!',
          status: true,
        };
        this.$refs.number.focus();
        return;
      }

      this.addressNumberError = {
        message: '',
        status: false,
      };

      if (this.$refs.addressInput && this.$refs.addressInput.addressString) {
        const updatedAddress = this.addNumberToAddress(
          this.addressNumber,
          this.$refs.addressInput.addressString
        );
        const secondAddress = String(
          this.$refs.addressInput.addressString
        ).replace(', ', `, ${this.addressNumber}, `);

        if (!this.$refs.addressInput.sessionToken)
          this.$refs.addressInput.generateNewSessionToken();

        const addressOption = await this.findAddress(
          String(updatedAddress).trim(),
          this.$refs.addressInput.sessionToken
        );

        // se o endereço encontrado não possui o número informado
        if (String(addressOption.title).indexOf(this.addressNumber) === -1) {
          this.addressNumberError = {
            message: 'Número não encontrado para esse endereço!',
            status: true,
          };
        }

        const toValidation = updatedAddress.split(',');
        if (toValidation[1].search(this.addressNumber) > 0) {
          this.$refs.addressInput.onAddressSelected(addressOption, 0, false);
        } else {
          const secondOption = await this.findAddress(
            String(secondAddress).trim(),
            this.$refs.addressInput.sessionToken
          );
          this.$refs.addressInput.onAddressSelected(secondOption, 0, false);
        }
      }
    },
    async findAddress(address, sessionToken) {
      const result = await AddressAPI.autoCompleteAddress(
        address,
        sessionToken
      );

      let addresses = result.getData([]);

      if (result.getData([]).length > 0) {
        addresses = addresses.map((a) => {
          return {
            title: a.description,
            data: a,
          };
        });
      }

      return addresses[0];
    },
    addNumberToAddress(number, address) {
      return String(address).replace(' -', `, ${number} -`);
    },
    onAddressSelected(option) {
      this.selectedAddress = null;
      if (!option.address) {
        return;
      }

      const location = option.address;

      if (!option.address.number) {
        if (this.addressNumber && this.addressNumber !== '') {
          this.addressNumberError = {
            message: 'Número não encontrado para esse endereço!',
            status: true,
          };
        }

        this.missingNumber = true;
        this.addressNumber = '';

        setTimeout(() => {
          this.$refs.number.focus();
        }, 0);

        return;
      }

      if (option.address.number !== this.addressNumber) {
        this.missingNumber = false;
      }

      this.selectedAddress = Location.fromObject(location);
      this.selectedOption = option;
    },
    async selectAddress() {
      // Verifica a distância do marcador em relação ao endereço escolhido
      if (!this.validGeolocationAddress()) {
        this.$refs.map.mapObject.setView(
          latLng(
            this.selectedAddress.geolocation.latitude,
            this.selectedAddress.geolocation.longitude
          ),
          17
        );

        this.updatedMarker = this.selectedAddress.geolocation;

        return alert(StringLanguage.errorGeolocationDistance);
      }

      const shortNameState = BrasilStates.getShortNameByName(
        this.selectedOption.address.state
      );
      AddressAPI.addressDDD(
        shortNameState,
        this.selectedOption.address.city
      ).then((response) => {
        this.phoneDDD =
          response.getData({ ddd: null }).ddd || this.original.phoneDDD;
        this.timezoneOffset = this.selectedOption.timezoneOffset / 60;

        this.address = this.selectedAddress;

        if (this.updatedMarker) this.address.geolocation = this.updatedMarker;

        this.selectedAddress = null;
        this.updatedMarker = null;
        this.updateLocation = false;
      });
    },
    markerMoved(center) {
      if (center) {
        // this.mapConfigs.markerPosition = center;
        this.updatedMarker = { latitude: center.lat, longitude: center.lng };
      }
    },
    isAddressValid() {
      const { address } = this;
      const fieldsToCheck = [
        'address',
        'number',
        'zipcode',
        'district',
        'city',
        'state',
        'country',
      ];

      for (const field of fieldsToCheck) {
        if (!`${address[field]}`.trim()) {
          return field;
        }
      }

      if (
        !address.geolocation ||
        !address.geolocation.latitude ||
        !address.geolocation.longitude
      ) {
        return 'geolocation';
      }

      return true;
    },
    set(response) {
      if (response.getErrors([]).length > 0) {
        return false;
      }
      if (response.getData({}).location || false) {
        const {
          location: address,
          keys,
          timezoneOffset,
          phoneDDD,
        } = response.getData({
          location: new Location(),
          keys: {},
          timezoneOffset: null,
          phoneDDD: null,
        });

        if (!address.address) {
          this.updateLocation = true;
          return;
        }

        const geolocation = JSON.parse(JSON.stringify(address.geolocation));
        const locationData = [
          address.address,
          address.number,
          address.zipcode,
          address.complement,
          address.district,
          address.city,
          address.state,
          address.country,
          address.observation,
          address.geolocation,
        ];

        Vue.set(this, 'address', new Location(...locationData));
        this.setOriginal('address', new Location(...locationData));

        this.mapConfigs.markerPosition = latLng(
          geolocation.latitude,
          geolocation.longitude
        );
        this.mapConfigs.minZoom = 10;
        this.mapConfigs.maxZoom = 18;

        this.$nextTick(() => {
          this.$refs.map &&
            this.$refs.map.mapObject &&
            this.$refs.map.mapObject.setView(
              latLng(geolocation.latitude, geolocation.longitude),
              15
            );
        });

        const times = response.getData({
          minDesk: null,
          maxDesk: null,
        }).delivery_time;
        let delivery_time = { minDesk: 0, maxDesk: 0 };
        if (times) {
          delivery_time = { minDesk: times.minDesk, maxDesk: times.maxDesk };
        }
        Vue.set(this, 'times', delivery_time);
        this.setOriginal('delivery_time', delivery_time);

        Vue.set(this, 'timezoneOffset', timezoneOffset);
        this.setOriginal('timezoneOffset', timezoneOffset);

        Vue.set(this, 'phoneDDD', phoneDDD);
        this.setOriginal('phoneDDD', phoneDDD);

        if (keys) {
          // Se o objeto possuir a propriedade hideOnlineLocation, utilizar ela, senão retornar valor true
          keys.hideOnlineLocation = keys.hasOwnProperty('hideOnlineLocation')
            ? keys.hideOnlineLocation
            : false;
          this.allowLocation = !keys.hideOnlineLocation;
          Vue.set(this, 'keys', keys);
          this.setOriginal('keys', keys);
        }
      } else {
        Vue.set(this, 'updateLocation', true);
      }
    },
    setOriginal(key, value) {
      Vue.set(this.original, key, JSON.parse(JSON.stringify(value || null)));
    },
    searchZipcode(zipcode) {
      const self = this;

      if (!zipcode || zipcode.length < 8) {
        alert(StringLanguage.errorZipCodeInvalid);
        Vue.set(this, 'address', new Location());
        return;
      }

      AccountApi.zipcode(zipcode).then((result) => {
        const address = result.getData({ zipCode: null });
        if (address.zipCode) {
          self.address.address = address.zipCode.address;
          self.address.district = address.zipCode.region;
          self.address.city = address.zipCode.city;
          self.address.state = address.zipCode.state;
          self.address.country = address.zipCode.country;
          self.address.geolocation = null;
          self.address.number = null;
          this.$forceUpdate();
          this.$refs.fieldNumber.focus();
        } else {
          alert(StringLanguage.errorZipCodeInvalid);
          Vue.set(this, 'address', new Location());
        }
      });
    },
    searchAddress() {
      AccountApi.address({
        ...this.address,
        address: `${this.address.number}, ${this.address.address}`,
      }).then((result) => {
        const address = result.getData({ addressObject: [null] })
          .addressObject[0];
        if (address) {
          this.address.geolocation = address.geolocation;
          this.mapConfigs.markerPosition = latLng(
            address.geolocation.latitude,
            address.geolocation.longitude
          );
          this.mapConfigs.minZoom = 10;
          this.mapConfigs.maxZoom = 18;
          this.$nextTick(() => {
            if (this.$refs.map) {
              this.$refs.map.mapObject.setView(
                latLng(
                  address.geolocation.latitude,
                  address.geolocation.longitude
                ),
                17
              );
            }
          });
        }
      });
    },
    validGeolocationAddress() {
      // Função para validar se o macador está no máximo a 200 metros do endereço escolhido

      const originalAddress = this.selectedAddress.geolocation;
      const currentAddress = this.updatedMarker;

      const distance = Geolocation.calculateDistance(
        originalAddress,
        currentAddress
      );

      if (!distance || distance <= 200) {
        return true;
      }

      return false;
    },
    async save() {
      const self = this;
      return StoreAPI.storeConfiguration({
        location: this.address,
        keys: this.keys,
        timezoneOffset: this.timezoneOffset,
        phoneDDD: this.phoneDDD,
        delivery_time: this.times,
      })
        .then(async (response) => {
          if (response.getErrors([]).length == 0) {
            const res = await StoreAPI.storeGetConfiguration();
            self.set(res);

            if (!this.onBoardDone) {
              return this.$router.push({ name: 'onboard' });
            }

            alert(StringLanguage.saveSuccess);
          } else {
            console.log(response.getErrors([]));
            alert(StringLanguage.saveError);
          }
          return null;
        })
        .catch((err) => {
          alert(StringLanguage.saveError);
        });
    },
  },
  computed: {
    formatedAddress() {
      const { address } = this;
      return `${address.address}${address.number ? `, ${address.number}` : ''}${
        address.district ? ` - ${address.district},` : ','
      } ${address.city} -
          ${address.state}, ${address.country} ${
        address.zipcode ? `- ${address.zipcode}` : ''
      }`;
    },
    ...mapState({
      isMobile: (state) => state.store.isMobile,
      onBoardDone: (state) => state.store.onBoardDone,
    }),
  },
  watch: {
    selectedAddress: {
      deep: true,
      handler() {
        this.$nextTick(() => {
          if (this.$refs.map) {
            this.$refs.map.mapObject.setView(
              latLng(
                this.selectedAddress.geolocation.latitude,
                this.selectedAddress.geolocation.longitude
              ),
              17
            );
          }
        });
      },
    },
    allowLocation: {
      deep: true,
      handler() {
        if (!this.allowLocation) {
          this.keys.hideOnlineLocation = true;
          this.times = { minDesk: 0, maxDesk: 0 };
        } else {
          this.keys.hideOnlineLocation = false;
        }
      },
    },
  },
  components: {
    TheMask,
    BaseTitle,
    BaseButton,
    BaseBox,
    BaseInput,
    BaseCheckbox,
    BaseLabel,
    BaseQuestion,
    AddressInput,
    LMap,
    LMarker,
    LTileLayer,
    BaseMessage,
  },
};
</script>

<style>
.leaflet-top,
.leaflet-bottom {
  z-index: 400 !important;
}
</style>
<style scoped>
@import url(https://unpkg.com/leaflet@1.6.0/dist/leaflet.css);
.hide-address {
  font-size: 14px;
  color: var(--label-primary);
  font-weight: 300;
}
.map-box {
  position: relative;
  height: 420px;
  max-height: calc(100vh - 440px);
}

.map-box > div {
  border-radius: 5px;
}

.map-pseudo-marker {
  position: absolute;
  top: calc(50% - 32px);
  left: calc(50% - 16px);
  z-index: 400;
  width: 32px;
  height: 32px;
}

.map-pseudo-marker i {
  font-size: 32px;
  color: var(--default);
  width: 100%;
  text-align: center;
}

.search-address {
  padding: 15px 20px 5px 20px !important;
}
.search-address input:focus {
  margin-top: 10px;
}
.address-box-title {
  margin-bottom: 25px;
  display: flex;
  justify-content: space-between;
  align-items: center;
}
.address-box-title .the-label {
  line-height: 19px;
}
.address-box-title .edit {
  cursor: pointer;
  color: var(--label-secondary);
  font-weight: 300;
  font-size: 1.2em;
  text-transform: uppercase;
}
.address-text {
  font-size: 1.4em;
  color: var(--label-primary);
  font-weight: 300;
  margin-top: -5px;
  margin-bottom: 30px;
}

.address {
  display: flex;
  align-items: flex-start;
}

.address .name {
  flex: 1;
}
.address .number {
  margin: 0 15px;
}
.address .next {
  flex: 0 10%;
  display: flex;
}

@media screen and (max-width: 991px) {
  .address {
    flex-wrap: wrap;
  }

  .address .name {
    flex: 0 100%;
    margin-bottom: 0;
  }
  .address .number {
    margin: 0;
    flex: 0 100%;
  }
  .address .next {
    flex: 0 100%;
  }
}
</style>
